export type ChartType = any;
export type DashboardMetric =
    | "BounceRate"
    | "TrafficShare"
    | "Visits"
    | "PagePerVisit"
    | "PagesViews"
    | "UniqueUsers"
    | "Duration"
    | "SegmentsBounceRateGroup"
    | "SegmentsGroupMonthlyVisits"
    | "SegmentsGroupTrafficShare"
    | "SegmentsPagePerVisitGroup"
    | "SegmentsPageViewsGroup"
    | "UniqueVisitsGroup"
    | "SegmentsVisitDurationGroup";

export const Y_AXIS_PERCENTS = ["BounceRate", "TrafficShare", "SegmentsBounceRateGroup", "SegmentsGroupTrafficShare"];
export const Y_AXIS_TIME = ["Duration", "SegmentsVisitDurationGroup"];
